export default "__VITE_ASSET__DxgYaLH2__"